var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "arrow-down_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#arrow-down_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "m12 12.915 4.073-4.057a.744.744 0 0 1 .514-.22.697.697 0 0 1 .54.22c.145.145.217.32.217.527a.718.718 0 0 1-.217.526l-4.048 4.049c-.294.293-.653.44-1.079.44-.426 0-.785-.147-1.079-.44L6.873 9.91a.744.744 0 0 1-.22-.514.697.697 0 0 1 .22-.54.718.718 0 0 1 .527-.217c.206 0 .382.073.527.218L12 12.915Z",
    fill: "currentColor"
  }))));
};
export default SvgArrowDown;